var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiptItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F4F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3332 13.6136V12.0002C22.3332 11.3601 22.0717 10.7764 21.65 10.3484C21.231 9.92984 20.6478 9.67274 20.0102 9.66687L22.3332 13.6136ZM22.3332 13.6136C22.3332 14.0689 22.1905 14.4081 21.9658 14.6328M22.3332 13.6136L21.9658 14.6328M21.9658 14.6328C21.7411 14.8576 21.4018 15.0002 20.9465 15.0002M21.9658 14.6328L20.9465 15.0002M20.9465 15.0002H18.9998M20.9465 15.0002H18.9998M18.9998 15.0002V10.6736C18.9998 10.1171 19.4572 9.66192 20.0101 9.66687L18.9998 15.0002Z",
    fill: "#6F00FF",
    stroke: "#6F00FF",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.1989 22.2678L10.2004 22.2666L11.3402 21.4135L10.1989 22.2678ZM10.1989 22.2678C9.98034 22.4334 9.66683 22.2805 9.66683 22.0002V12.6668V12.0002C9.66683 11.307 9.82446 10.7313 10.1691 10.3322C10.5059 9.94222 11.0684 9.66683 12.0002 9.66683H12.6668H18.6686M10.1989 22.2678L18.6686 9.66683M18.6686 9.66683C18.4584 9.94577 18.3335 10.2923 18.3335 10.6668V22.0002C18.3335 22.2703 18.0212 22.4305 17.7993 22.2662C17.7991 22.2661 17.799 22.266 17.7989 22.2659L16.6615 21.4145C16.2666 21.1122 15.7069 21.1554 15.3578 21.5045L14.2378 22.6245C14.108 22.7542 13.8926 22.7543 13.7627 22.6247C13.7627 22.6246 13.7626 22.6245 13.7625 22.6245L12.6566 21.5118L12.6559 21.5111C12.3001 21.1553 11.7414 21.1128 11.3404 21.4133L18.6686 9.66683Z",
    fill: "#6F00FF",
    stroke: "#6F00FF",
    strokeWidth: 0.666667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.5067H16C16.0892 16.5067 16.1667 16.5841 16.1667 16.6733C16.1667 16.7626 16.0892 16.84 16 16.84H14C13.9108 16.84 13.8333 16.7626 13.8333 16.6733C13.8333 16.5841 13.9108 16.5067 14 16.5067Z",
    fill: "#6F00FF",
    stroke: "#6F00FF",
    strokeWidth: 0.666667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.173H14C13.9108 14.173 13.8333 14.0956 13.8333 14.0063C13.8333 13.9171 13.9108 13.8397 14 13.8397H16C16.0892 13.8397 16.1667 13.9171 16.1667 14.0063C16.1667 14.0956 16.0892 14.173 16 14.173Z",
    fill: "#6F00FF",
    stroke: "#6F00FF",
    strokeWidth: 0.666667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9801 13.3398C11.6068 13.3398 11.3135 13.6398 11.3135 14.0065C11.3135 14.3732 11.6135 14.6732 11.9801 14.6732C12.3468 14.6732 12.6468 14.3732 12.6468 14.0065C12.6468 13.6398 12.3468 13.3398 11.9801 13.3398Z",
    fill: "#6F00FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9801 16.0063C11.6068 16.0063 11.3135 16.3063 11.3135 16.673C11.3135 17.0397 11.6135 17.3397 11.9801 17.3397C12.3468 17.3397 12.6468 17.0397 12.6468 16.673C12.6468 16.3063 12.3468 16.0063 11.9801 16.0063Z",
    fill: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptItem);
export default __webpack_public_path__ + "static/media/receipt-item.00c9b46232c6c676323cbf9e60aec9b5.svg";
export { ForwardRef as ReactComponent };